import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { actionModalCloseAll } from "../../modals/actionModal";
import { TypeActionViewport } from "../actionViewport";
export var epicViewportCloseModals = function (action$, state$) {
    return action$.pipe(ofType(TypeActionViewport.CenterOn), mapTo(actionModalCloseAll()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epics/epicViewportCloseModals.ts
// module id = 2500
// module chunks = 3